import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConfigurationService} from '../../configuration.service';
import {UrlEndpoints} from '../../../definitions/url-endpoints';
import { ConfigurationModel } from 'src/app/models/configuration.model';

@Injectable({
    providedIn: 'root'
})
export class ProductResourceService {

    constructor(private http: HttpClient,
                private configuration: ConfigurationService,
                private urlEndpoints: UrlEndpoints,
                private config: ConfigurationService) {
    }

    getDepartments() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.deptListEndPoint)).toPromise();
    }

    getGroupList() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.deptGroupListEndPoint)).toPromise();
    }

    getProduct() {
        const conf = this.configuration.getConfiguration();
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.ProductTypeListByTstampWithStockLevelsEndPoint
            + this.configuration.getConfiguration().productDateTime + '/' + this.configuration.getConfiguration().selectedDepot )).toPromise();
    }

    getSparesForWs() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.sparesUsedInWsEndPoint)).toPromise();
    }

    getSaccess() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.saccessListByTstampEndPoint
            + this.configuration.getConfiguration().saccessDateTime)).toPromise();
    }

    getPriceList() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.priceListEndPoint)).toPromise();
    }

    getPriceListDetails() {
        const mobileConfig = this.config.getMobileConfiguration();
        if (mobileConfig.mobilehireScaffoldingInUse === 0) {
            return this.http.get(this.configuration.buildUrl(this.urlEndpoints.getPriceListDetailsEndPoint
                + this.configuration.getConfiguration().priceListDetailsDateTime)).toPromise();
        }

    }

    getPolicy() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.policyListEndPoint)).toPromise();
    }

    getPTSerial() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.getPTSerialBeansByTstampEndPoint
            + this.configuration.getConfiguration().ptSerialDateTime)).toPromise();
    }

    getProductWithBarcodeForStockTake() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.getProductTypeBarcodeStockTake
            + this.configuration.getConfiguration().productBarcodeDateTime)).toPromise();
    }

    getAllBinLocations(){
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.getAllBinLocations)).toPromise(); 
    }


}
